import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgReduxModule } from "@angular-redux/store";
import { NgRedux, DevToolsExtension } from "@angular-redux/store";
import { rootReducer, ArchitectUIState } from "./ThemeOptions/store";
import { ConfigActions } from "./ThemeOptions/store/config.actions";
import { AppRoutingModule } from "./app-routing.module";
import { LoadingBarRouterModule } from "@ngx-loading-bar/router";

import { CommonModule } from "@angular/common";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { AppComponent } from "./app.component";
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxPaginationModule } from "ngx-pagination";
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { ToastrModule } from "ngx-toastr";
// BOOTSTRAP COMPONENTS

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { ChartsModule } from "ng2-charts";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

// LAYOUT

import { BaseLayoutComponent } from "./Layout/base-layout/base-layout.component";
import { PagesLayoutComponent } from "./Layout/pages-layout/pages-layout.component";
import { PageTitleComponent } from "./Layout/Components/page-title/page-title.component";

// HEADER

import { HeaderComponent } from "./Layout/Components/header/header.component";
import { SearchBoxComponent } from "./Layout/Components/header/elements/search-box/search-box.component";
import { UserBoxComponent } from "./Layout/Components/header/elements/user-box/user-box.component";

// SIDEBAR

import { SidebarComponent } from "./Layout/Components/sidebar/sidebar.component";
import { LogoComponent } from "./Layout/Components/sidebar/elements/logo/logo.component";

// FOOTER

import { FooterComponent } from "./Layout/Components/footer/footer.component";

// DEMO PAGES

// Dashboards

import { AnalyticsComponent } from "./DemoPages/Dashboards/analytics/analytics.component";

// Pages

import { ForgotPasswordBoxedComponent } from "./DemoPages/UserPages/forgot-password-boxed/forgot-password-boxed.component";
import { LoginBoxedComponent } from "./DemoPages/UserPages/login-boxed/login-boxed.component";
import { RegisterBoxedComponent } from "./DemoPages/UserPages/register-boxed/register-boxed.component";

// Elements

import { StandardComponent } from "./DemoPages/Elements/Buttons/standard/standard.component";
import { DropdownsComponent } from "./DemoPages/Elements/dropdowns/dropdowns.component";
import { CardsComponent } from "./DemoPages/Elements/cards/cards.component";
import { ListGroupsComponent } from "./DemoPages/Elements/list-groups/list-groups.component";
import { TimelineComponent } from "./DemoPages/Elements/timeline/timeline.component";
import { IconsComponent } from "./DemoPages/Elements/icons/icons.component";

// Components

import { AccordionsComponent } from "./DemoPages/Components/accordions/accordions.component";
import { TabsComponent } from "./DemoPages/Components/tabs/tabs.component";
import { CarouselComponent } from "./DemoPages/Components/carousel/carousel.component";
import { ModalsComponent } from "./DemoPages/Components/modals/modals.component";
import { ProgressBarComponent } from "./DemoPages/Components/progress-bar/progress-bar.component";
import { PaginationComponent } from "./DemoPages/Components/pagination/pagination.component";
import { TooltipsPopoversComponent } from "./DemoPages/Components/tooltips-popovers/tooltips-popovers.component";

// Tables

import { RegularComponent } from "./DemoPages/Tables/regular/regular.component";
import { TablesMainComponent } from "./DemoPages/Tables/tables-main/tables-main.component";

// Widgets

import { ChartBoxes3Component } from "./DemoPages/Widgets/chart-boxes3/chart-boxes3.component";

// Forms Elements

import { ControlsComponent } from "./DemoPages/Forms/Elements/controls/controls.component";
import { LayoutComponent } from "./DemoPages/Forms/Elements/layout/layout.component";

// Charts

import { ChartjsComponent } from "./DemoPages/Charts/chartjs/chartjs.component";

// Chart.js Examples

import { LineChartComponent } from "./DemoPages/Charts/chartjs/examples/line-chart/line-chart.component";
import { BarChartComponent } from "./DemoPages/Charts/chartjs/examples/bar-chart/bar-chart.component";
import { ScatterChartComponent } from "./DemoPages/Charts/chartjs/examples/scatter-chart/scatter-chart.component";
import { RadarChartComponent } from "./DemoPages/Charts/chartjs/examples/radar-chart/radar-chart.component";
import { PolarAreaChartComponent } from "./DemoPages/Charts/chartjs/examples/polar-area-chart/polar-area-chart.component";
import { BubbleChartComponent } from "./DemoPages/Charts/chartjs/examples/bubble-chart/bubble-chart.component";
import { DynamicChartComponent } from "./DemoPages/Charts/chartjs/examples/dynamic-chart/dynamic-chart.component";
import { DoughnutChartComponent } from "./DemoPages/Charts/chartjs/examples/doughnut-chart/doughnut-chart.component";
import { PieChartComponent } from "./DemoPages/Charts/chartjs/examples/pie-chart/pie-chart.component";
import { UsersComponent } from "./users/users.component";
import { DriversComponent } from "./drivers/drivers.component";
import { VehicleComponent } from "./vehicle/vehicle.component";
import { PackageComponent } from "./package/package.component";
import { PaymentsComponent } from "./payments/payments.component";
import { CityComponent } from "./city/city.component";
import { BusinessComponent } from "./business/business.component";
import { SettingComponent } from "./setting/setting.component";
import { ActiveDriversComponent } from "./active-drivers/active-drivers.component";
import { AddDriversComponent } from "./add-drivers/add-drivers.component";
import { AddVehiclesComponent } from "./add-vehicles/add-vehicles.component";
import { AddPackageComponent } from "./add-package/add-package.component";
import { HeadersInterceptor } from "./headers.interceptor";
import { AdminComponent } from "./admin/admin.component";
import { AddAdminComponent } from "./add-admin/add-admin.component";
import { ViewUserDetailsComponent } from "./view-user-details/view-user-details.component";
import { ViewVehicleDetailsComponent } from "./view-vehicle-details/view-vehicle-details.component";
// import { HaversineService } from "ng2-haversine";
import { DatePipe } from "@angular/common";
import { ViewPackageDetailsComponent } from "./view-package-details/view-package-details.component";
import { EditPackageComponent } from "./edit-package/edit-package.component";
import { VehicleBookingComponent } from "./vehicle-booking/vehicle-booking.component";
import { PickDropRequestComponent } from "./pick-drop-request/pick-drop-request.component";
import { PackerMoverRequestComponent } from "./packer-mover-request/packer-mover-request.component";
import { DriverPartnerRequestComponent } from "./driver-partner-request/driver-partner-request.component";
import { EnterpriseRequestComponent } from "./enterprise-request/enterprise-request.component";
import { ViewPackerMoverRequestComponent } from "./view-packer-mover-request/view-packer-mover-request.component";
import { VendorComponent } from "./vendor/vendor.component";
// import { SocketIoModule, SocketIoConfig } from "ngx-socket-io";
import { environment } from "src/environments/environment";
import { WebSocketService } from "./web-socket.service";
import { UploadComponent } from "./upload/upload.component";
import { TrackAllPackagesComponent } from "./track-all-packages/track-all-packages.component";
import { AgmCoreModule } from "@agm/core";
import { AgmDirectionModule } from "agm-direction";
import { PackageTrackComponent } from "./package-track/package-track.component";
// import { SettingsComponent } from './settings/settings.component';
import { PackageNotificationComponent } from "./Layout/Components/header/elements/package-notification/package-notification.component";
import { QrConfigComponent } from "./qr-config/qr-config.component";
import { QrConfigTableComponent } from "./qr-config-table/qr-config-table.component";
import { PackageConfigurationComponent } from "./configuration/packageConfiguration/package-configuration/package-configuration.component";
import { GetPackageConfigComponent } from "./configuration/packageConfiguration/get-package-config/get-package-config.component";
import { AddPackersMoversConfigComponent } from "./configuration/packersMoversConfiguration/add-packers-movers-config/add-packers-movers-config.component";
import { GetPackersMoversConfigComponent } from "./configuration/packersMoversConfiguration/get-packers-movers-config/get-packers-movers-config.component";
import { ViewAndUpdateConfigComponent } from "./configuration/view-and-update-config/view-and-update-config.component";
import { AddConfigurationComponent } from "./configuration/add-configuration/add-configuration.component";
import { DriverWithdrawalRequestComponent } from "./driver-withdrawal-request/driver-withdrawal-request.component";
import { DriverWalletComponent } from "./driver-wallet/driver-wallet.component";
import { DriverDepositeTransactionComponent } from "./driver-deposite-transaction/driver-deposite-transaction.component";
import { VehiclesComponent } from "./vacantVehicle/vehicles/vehicles.component";
import { AddAndEditVehicleComponent } from "./vacantVehicle/vehicles/add-and-edit-vehicle/add-and-edit-vehicle.component";
import { TruckTyresComponent } from "./vacantVehicle/truck-tyres/truck-tyres.component";
import { AddEditTyreComponent } from "./vacantVehicle/truck-tyres/add-edit-tyre/add-edit-tyre.component";
import { ViewVehicleComponent } from "./vacantVehicle/vehicles/view-vehicle/view-vehicle.component";
import { DriverPostAddComponent } from "./vacantVehicle/postAdds/driver-post-add/driver-post-add.component";
import { UserPostAddComponent } from "./vacantVehicle/postAdds/user-post-add/user-post-add.component";
import { ViewLoadComponent } from "./vacantVehicle/postAdds/view-load/view-load.component";
import { PostLoadComponent } from "./vacantVehicle/postAdds/post-load/post-load.component";
import { PostVacantVehicleComponent } from "./vacantVehicle/postAdds/post-vacant-vehicle/post-vacant-vehicle.component";
import { SubscriptionListComponent } from "./Subscription/subscription-list/subscription-list.component";
import { AddAndEditSubscriptionPlanComponent } from "./Subscription/subscription-list/add-and-edit-subscription-plan/add-and-edit-subscription-plan.component";
import { SupportRequestsComponent } from './support-requests/support-requests.component';
import { BidsComponent } from './vacantVehicle/bids/bids.component';
import { DriverReviewsComponent } from './driver-reviews/driver-reviews.component';
import { DriverLoadAlertComponent } from './vacantVehicle/driver-load-alert/driver-load-alert.component';
import { OnlineDriversComponent } from './online-drivers/online-drivers.component';
import { UserEnterpriseRequestsComponent } from './Enterprise/user-enterprise-requests/user-enterprise-requests.component';
import { ViewEnterpriseDetailsComponent } from './Enterprise/view-enterprise-details/view-enterprise-details.component';
import { SubscriptionPlansComponent } from './Enterprise/Subscription/subscription-plans/subscription-plans.component';
import { AddUpdateSubscriptionPlanComponent } from './Enterprise/Subscription/add-update-subscription-plan/add-update-subscription-plan.component';
import { EmployeeRequestsComponent } from './Enterprise/employee-requests/employee-requests.component';
import { BranchRequestsComponent } from './Enterprise/branch-requests/branch-requests.component';
import { ViewTripsComponent } from './Enterprise/Trips/view-trips/view-trips.component';
import { TripsComponent } from './Enterprise/Trips/trips/trips.component';
import { TrackTripComponent } from './Enterprise/Trips/track-trip/track-trip.component';
import { UserDepositsComponent } from './userWallet/user-deposits/user-deposits.component';
import { UserWithdrwalRequestsComponent } from './userWallet/user-withdrwal-requests/user-withdrwal-requests.component';
import { UserTransactionsComponent } from './userWallet/user-transactions/user-transactions.component';
import { EnterprisesComponent } from './Enterprise/enterprises/enterprises.component';
import { EnterpriseDashboardComponent } from './Enterprise/enterprise-dashboard/enterprise-dashboard.component';
import { TripAnalyticsComponent } from './Enterprise/trip-analytics/trip-analytics.component';
import { UserLoadAlertComponent } from './vacantVehicle/user-load-alert/user-load-alert.component';
import { GetUserDetailsComponent } from './packersMovers/get-user-details/get-user-details.component';
import { GetPackersMoversListComponent } from './packersMovers/get-packers-movers-list/get-packers-movers-list.component';
import { ViewPackersMoversComponent } from './packersMovers/view-packers-movers/view-packers-movers.component';
import { ViewUsersDetailsComponent } from './packersMovers/view-users-details/view-users-details.component';
import { SendPushNotificationComponent } from './notifications/send-push-notification/send-push-notification.component';
import { ViewNotificationHistoryComponent } from './notifications/view-notification-history/view-notification-history.component';
import { WarehouseListComponent } from './warehouse/warehouse-list/warehouse-list.component';
import { ViewWarehouseComponent } from './warehouse/view-warehouse/view-warehouse.component';
import { DriverLoadSearchListComponent } from './vacantVehicle/searchNotification/driver-load-search-list/driver-load-search-list.component';
import { UserVacantVehicleSearchListComponent } from './vacantVehicle/searchNotification/user-vacant-vehicle-search-list/user-vacant-vehicle-search-list.component';
import { UserViewVacantVehicleSearchComponent } from './vacantVehicle/searchNotification/user-view-vacant-vehicle-search/user-view-vacant-vehicle-search.component';
import { DriverViewLoadSearchComponent } from './vacantVehicle/searchNotification/driver-view-load-search/driver-view-load-search.component';

// const config: SocketIoConfig = { url: environment.socketUrl, options: {} };

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  declarations: [
    // LAYOUT

    AppComponent,
    BaseLayoutComponent,
    PagesLayoutComponent,
    PageTitleComponent,

    // HEADER

    HeaderComponent,
    SearchBoxComponent,
    UserBoxComponent,

    // SIDEBAR

    SidebarComponent,
    LogoComponent,

    // FOOTER

    FooterComponent,

    // DEMO PAGES

    // Dashboards

    AnalyticsComponent,

    // User Pages

    ForgotPasswordBoxedComponent,
    LoginBoxedComponent,
    RegisterBoxedComponent,

    // Elements

    StandardComponent,
    IconsComponent,
    DropdownsComponent,
    CardsComponent,
    ListGroupsComponent,
    TimelineComponent,

    // Components

    AccordionsComponent,
    TabsComponent,
    CarouselComponent,
    ModalsComponent,
    ProgressBarComponent,
    PaginationComponent,
    TooltipsPopoversComponent,

    // Tables

    RegularComponent,
    TablesMainComponent,

    // Dashboard Boxes

    ChartBoxes3Component,

    // Form Elements

    ControlsComponent,
    LayoutComponent,

    // CHARTS

    ChartjsComponent,

    // Chart.js Examples

    LineChartComponent,
    BarChartComponent,
    DoughnutChartComponent,
    RadarChartComponent,
    PieChartComponent,
    PolarAreaChartComponent,
    DynamicChartComponent,
    BubbleChartComponent,
    ScatterChartComponent,
    UsersComponent,
    DriversComponent,
    VehicleComponent,
    PackageComponent,
    PaymentsComponent,
    CityComponent,
    BusinessComponent,
    SettingComponent,
    ActiveDriversComponent,
    AddDriversComponent,
    AddVehiclesComponent,
    AddPackageComponent,
    AdminComponent,
    AddAdminComponent,
    ViewUserDetailsComponent,
    ViewVehicleDetailsComponent,
    ViewPackageDetailsComponent,
    EditPackageComponent,
    VehicleBookingComponent,
    PickDropRequestComponent,
    PackerMoverRequestComponent,
    DriverPartnerRequestComponent,
    EnterpriseRequestComponent,
    ViewPackerMoverRequestComponent,
    VendorComponent,
    UploadComponent,
    TrackAllPackagesComponent,
    PackageTrackComponent,
    // SettingsComponent,
    PackageNotificationComponent,
    QrConfigComponent,
    QrConfigTableComponent,
    PackageConfigurationComponent,
    GetPackageConfigComponent,
    AddPackersMoversConfigComponent,
    GetPackersMoversConfigComponent,
    ViewAndUpdateConfigComponent,
    AddConfigurationComponent,
    DriverWithdrawalRequestComponent,
    DriverWalletComponent,
    DriverDepositeTransactionComponent,
    VehiclesComponent,
    AddAndEditVehicleComponent,
    TruckTyresComponent,
    AddEditTyreComponent,
    ViewVehicleComponent,
    DriverPostAddComponent,
    UserPostAddComponent,
    ViewLoadComponent,
    PostLoadComponent,
    PostVacantVehicleComponent,
    SubscriptionListComponent,
    AddAndEditSubscriptionPlanComponent,
    SupportRequestsComponent,
    BidsComponent,
    DriverReviewsComponent,
    DriverLoadAlertComponent,
    OnlineDriversComponent,
    UserEnterpriseRequestsComponent,
    ViewEnterpriseDetailsComponent,
    SubscriptionPlansComponent,
    AddUpdateSubscriptionPlanComponent,
    EmployeeRequestsComponent,
    BranchRequestsComponent,
    ViewTripsComponent,
    TripsComponent,
    TrackTripComponent,
    UserDepositsComponent,
    UserWithdrwalRequestsComponent,
    UserTransactionsComponent,
    EnterprisesComponent,
    EnterpriseDashboardComponent,
    TripAnalyticsComponent,
    UserLoadAlertComponent,
    GetUserDetailsComponent,
    GetPackersMoversListComponent,
    ViewPackersMoversComponent,
    ViewUsersDetailsComponent,
    SendPushNotificationComponent,
    ViewNotificationHistoryComponent,
    WarehouseListComponent,
    ViewWarehouseComponent,
    DriverLoadSearchListComponent,
    UserVacantVehicleSearchListComponent,
    UserViewVacantVehicleSearchComponent,
    DriverViewLoadSearchComponent,
    
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgReduxModule,
    CommonModule,
    LoadingBarRouterModule,
    NgxPaginationModule,
    NgxSpinnerModule,
    GooglePlaceModule,
    // SocketIoModule.forRoot(config),
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: "toast-bottom-right",
      preventDuplicates: true,
      closeButton: true,
      easing: "ease-in",
    }),
    // Angular Bootstrap Components

    PerfectScrollbarModule,
    NgbModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,

    // Charts

    ChartsModule,
    AgmDirectionModule,
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyBU2tle-WOyc5XJcxll-KVl2fG9Bs9yD74",
    }),
  ],
  providers: [
    WebSocketService,
    DatePipe,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      // DROPZONE_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
      // DEFAULT_DROPZONE_CONFIG,
    },
    ConfigActions,
    HeadersInterceptor,
    { provide: HTTP_INTERCEPTORS, useClass: HeadersInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(
    private ngRedux: NgRedux<ArchitectUIState>,
    private devTool: DevToolsExtension
  ) {
    this.ngRedux.configureStore(
      rootReducer,
      {} as ArchitectUIState,
      [],
      [devTool.isEnabled() ? devTool.enhancer() : (f) => f]
    );
  }
}
